import { useEffect, useMemo, useRef, useState } from "react";
import cn from "classnames";
import { Select } from "components/ui/Select";
import type { KeyProduct } from "./apikeys.model";

type CreateKeyRowProps = {
  products: KeyProduct[];
  creating: boolean;
  onSubmit: (name: string, serviceTool: string) => void;
};

/** Mounts only when opened, so the name field takes focus as the prototype's `#empty-create` does. */
export const CreateKeyRow = ({ products, creating, onSubmit }: CreateKeyRowProps) => {
  const [name, setName] = useState("");
  const [picked, setPicked] = useState<string | null>(null);
  const [touched, setTouched] = useState(false);
  const nameRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    nameRef.current?.focus();
  }, []);

  const options = useMemo(
    () =>
      products.map((product) => ({
        value: product.serviceTool,
        label: product.name,
        icon: <img className="pccube" src={product.cube} alt="" width={24} height={24} />,
      })),
    [products]
  );

  // The catalogue may replace the built-in list after the row opened.
  const serviceTool = options.some((option) => option.value === picked) ? (picked as string) : options[0]?.value;

  const nameMissing = touched && name.trim() === "";

  const submit = () => {
    setTouched(true);
    if (name.trim() === "" || serviceTool === undefined) {
      nameRef.current?.focus();
      return;
    }

    onSubmit(name.trim(), serviceTool);
  };

  return (
    <div className="pcnew">
      <div className={cn("pcnew__f", { "is-bad": nameMissing })}>
        <span>Key name</span>
        <input
          ref={nameRef}
          type="text"
          name="keyname"
          value={name}
          placeholder="e.g. Farnell tracking"
          onChange={(event) => setName(event.target.value)}
          onKeyDown={(event) => {
            if (event.key === "Enter") {
              submit();
            }
          }}
        />
        <small className="pcf__err">Enter a name</small>
      </div>

      <div className="pcnew__f">
        <span>Production server</span>
        <Select
          value={serviceTool ?? ""}
          options={options}
          onChange={setPicked}
          ariaLabel="Product this key is for"
          variant="cube"
        />
      </div>

      <button type="button" className="pcbtn pcbtn--main pcnew__go" disabled={creating} onClick={submit}>
        {creating ? "Generating…" : "Generate key"}
      </button>
    </div>
  );
};
